import 'scss/services/lexicalAnalysis.scss'
import 'babel-polyfill'
import {
  serviceTopbar
} from 'js/libs/utils-services'

import { config } from 'config'
import { lexicalAnalysist } from 'js/api/services'
import 'js/libs/gt'

var demoTextList = [
  '讯飞开放平台作为开放的智能交互技术服务平台，致力于为开发者打造一站式智能人机交互解决方案。',
  '人工智能是一门极富挑战性的科学，从事这项工作的人必须懂得计算机知识，心理学和哲学。',
  'AI大学堂是由讯飞开放平台打造的人工智能专业学习、交流和培训的AI学习平台。作为国内AI在线学习平台，旨在为 AI 领域开发者、爱好者提供丰富的资源、专业的课程以及共享的服务。'
]
var n = 0

var mnData = [
  {"data":{"pos":[{"code":"b","name":"状态词"},{"code":"wp","name":"标点"},{"code":"v","name":"动词"},{"code":"n","name":"名词"},{"code":"m","name":"数词"},{"code":"q","name":"量词"},{"code":"p","name":"介词"},{"code":"u","name":"助词"}],"nameEntity":[],"word":[{"text":"讯飞","type":"n"},{"text":"开放","type":"v"},{"text":"平台","type":"n"},{"text":"作为","type":"v"},{"text":"业内","type":"n"},{"text":"一","type":"m"},{"text":"个","type":"q"},{"text":"开放","type":"v"},{"text":"的","type":"u"},{"text":"智能","type":"n"},{"text":"交互","type":"b"},{"text":"技术","type":"n"},{"text":"服务","type":"v"},{"text":"平台","type":"n"},{"text":"，","type":"wp"},{"text":"致力","type":"v"},{"text":"于","type":"p"},{"text":"为","type":"p"},{"text":"开发者","type":"n"},{"text":"打造","type":"v"},{"text":"一站式","type":"n"},{"text":"智能","type":"n"},{"text":"人机","type":"n"},{"text":"交互","type":"v"},{"text":"解决","type":"v"},{"text":"方案","type":"n"},{"text":"。","type":"wp"}]}},
  {"data":{"pos":[{"code":"wp","name":"标点"},{"code":"v","name":"动词"},{"code":"c","name":"连词"},{"code":"n","name":"名词"},{"code":"d","name":"副词"},{"code":"m","name":"数词"},{"code":"r","name":"代词"},{"code":"q","name":"量词"},{"code":"u","name":"助词"}],"nameEntity":[],"word":[{"text":"人工智能","type":"n"},{"text":"是","type":"v"},{"text":"一","type":"m"},{"text":"门","type":"q"},{"text":"极","type":"d"},{"text":"富","type":"v"},{"text":"挑战性","type":"n"},{"text":"的","type":"u"},{"text":"科学","type":"n"},{"text":"，","type":"wp"},{"text":"从事","type":"v"},{"text":"这","type":"r"},{"text":"项","type":"q"},{"text":"工作","type":"v"},{"text":"的","type":"u"},{"text":"人","type":"n"},{"text":"必须","type":"d"},{"text":"懂得","type":"v"},{"text":"计算机","type":"n"},{"text":"知识","type":"n"},{"text":"，","type":"wp"},{"text":"心理学","type":"n"},{"text":"和","type":"c"},{"text":"哲学","type":"n"},{"text":"。","type":"wp"}]}},
  {"data":{"pos":[{"code":"ws","name":"外来词"},{"code":"wp","name":"标点"},{"code":"v","name":"动词"},{"code":"c","name":"连词"},{"code":"nl","name":"处所词"},{"code":"n","name":"名词"},{"code":"m","name":"数词"},{"code":"a","name":"形容词"},{"code":"p","name":"介词"},{"code":"q","name":"量词"},{"code":"u","name":"助词"}],"nameEntity":[{"valueList":["AI","大学"],"typeName":"机构名"}],"word":[{"text":"AI","type":"ws"},{"text":"大学","type":"n"},{"text":"是","type":"v"},{"text":"由","type":"p"},{"text":"讯","type":"n"},{"text":"飞","type":"v"},{"text":"开放","type":"v"},{"text":"平台","type":"n"},{"text":"打造","type":"v"},{"text":"的","type":"u"},{"text":"人工智能","type":"n"},{"text":"专业","type":"n"},{"text":"学习","type":"v"},{"text":"、","type":"wp"},{"text":"交流","type":"v"},{"text":"和","type":"c"},{"text":"培训","type":"v"},{"text":"的","type":"u"},{"text":"AI","type":"ws"},{"text":"学习","type":"v"},{"text":"平台","type":"n"},{"text":"。","type":"wp"},{"text":"作为","type":"v"},{"text":"国内","type":"nl"},{"text":"首","type":"m"},{"text":"个","type":"q"},{"text":"AI","type":"ws"},{"text":"在线","type":"n"},{"text":"学习","type":"v"},{"text":"平台","type":"n"},{"text":"，","type":"wp"},{"text":"旨在","type":"v"},{"text":"为","type":"p"},{"text":"AI","type":"ws"},{"text":"领域","type":"n"},{"text":"开发者","type":"n"},{"text":"、","type":"wp"},{"text":"爱好者","type":"n"},{"text":"提供","type":"v"},{"text":"丰富","type":"a"},{"text":"的","type":"u"},{"text":"资源","type":"n"},{"text":"、","type":"wp"},{"text":"专业","type":"n"},{"text":"的","type":"u"},{"text":"课程","type":"n"},{"text":"以及","type":"c"},{"text":"共享","type":"v"},{"text":"的","type":"u"},{"text":"服务","type":"v"},{"text":"。","type":"wp"}]}}
]

var functionalExperienceModel = {
  result: {},
  // 增加极验
  geetestApi1: function () {
    var that = this
    var config = this.config
    $.ajax({
      url: '/herapi/plug/validate?t=' + (new Date()).getTime(),
      type: 'get',
      dataType: 'json',
      success: function (data) {
        // 调用 initGeetest 进行初始化
        // 参数1：配置参数
        // 参数2：回调，回调的第一个参数验证码对象，之后可以使用它调用相应的接口
        initGeetest({
          // 以下 4 个配置参数为必须，不能缺少
          gt: data.data.gt,
          challenge: data.data.challenge,
          offline: !data.data.success, // 表示用户后台检测极验服务器是否宕机
          new_captcha: data.data.new_captcha, // 用于宕机时表示是新验证码的宕机
          product: 'bind', // 产品形式，包括：float，popup
          width: '300px'
          // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
        }, function (captchaObj) {
          captchaObj.onReady(function () {
          }).onSuccess(function () {
            that.result = captchaObj.getValidate()
            if (!that.result) {
              return alert('请完成验证')
            }
            that.analysis()
          })
          // 开始分析
          $('#startLoad').on('click', function () {
            if (that.checkTextarea()) {
              captchaObj.verify()
            }
          })
        })
      }
    })
  },
  analysis: function (isDemo) {
    var that = this

    if (isDemo) {
      that.render(mnData[n].data)
    } else {
      if (that.checkTextarea()) {
        var params = {
          challenge: that.result.geetest_challenge,
          validate: that.result.geetest_validate,
          seccode: that.result.geetest_seccode,
          text: that.checkTextarea()
        }
        $.mask()
        lexicalAnalysist(params).then(function (result) {
          $.mask('hide')
          if(result.data===null){
            that.render({nameEntity:[],pos:[],word:[]})
            return
          }
          if (result.flag && result.data) {
            that.render(result.data)
          } else if (result.code === '99999' || result.code === 99999) {
            $.alerts.alert('系统异常，请稍后再试')
          } else if (result.code === '20011' || result.code === 20011) {
            $.alerts.alert('验证码校验不通过')
          }
        })
      }
    }
  },
  render: function (res) {
    var that = this

    that.renderParticipleAndPart(res.word, res.pos)
    that.renderNamedEntity(res.nameEntity)
  },
  // 渲染分词&词性标注
  renderParticipleAndPart: function (res, type) {
    var participleTmpl = ''
    var partOfSpeechTmpl = ''

    for (let i = 0, len = res.length; i < len; i++) {
      participleTmpl += `<li class="type-${res[i].type}" data-code="type-${res[i].type}">${res[i].text}</li>`
    }
    for (let j = 0, num = type.length; j < num; j++) {
      partOfSpeechTmpl += `<li class="type-${type[j].code}" data-code="type-${type[j].code}">${type[j].name}</li>`
    }
    $('#participle').empty().html(participleTmpl)
    $('#partOfSpeech').empty().html(partOfSpeechTmpl)
    // 触发第一个分词选中
    setTimeout(function () {
      $('#participle li:first-child').trigger('click')
    }, 50)
  },
  // 渲染命名实体识别结果
  renderNamedEntity: function (res) {
    var tmpl = ''
    var itemsTmpl = ''

    $('#namedEntityWrap').empty()
    if (res && res.length > 0) {
      for (let i = 0, len = res.length; i < len; i++) {
        itemsTmpl = ''
        for (let j = 0, num = res[i].valueList.length; j < num; j++) {
          itemsTmpl += `<li>${res[i].valueList[j]}</li>`
        }
        tmpl += `<div class="type-item">
          <div class="type-name select">${res[i].typeName}</div>
          <ul>${itemsTmpl}</ul>
        </div>`
      }
      $('#namedEntityWrap').html(tmpl)
    }
  },
  // 切换示例文本
  changeDemo: function () {
    if (n >= (demoTextList.length - 1)) {
      n = 0
    } else {
      n += 1
    }
    $('#analysisText').val(demoTextList[n])
    this.analysis(true)
  },
  // 检查文本框输入内容
  checkTextarea: function () {
    var text = $('#analysisText').val().trim()
    var rules = new RegExp(/^[a-zA-Z\d]+$/)

    if (text === '') {
      $.alerts.alert('您没有输入内容')
      return false
    } else if (text.length > 100) {
      $.alerts.alert('最多输入100字')
      return false
    } else if (rules.test(text.replace(/\s/g,''))) {
      $.alerts.alert('抱歉，仅支持中文内容分析')
      return false
    } else {
      return String(text)
    }
  },
  addEvent: function () {
    var that = this
    // 更换示例
    $(document).on('click', '#changText', function () {
      that.changeDemo()
    })
    // 分词&词性点击效果
    $(document).on('click', '#participleAndPart li', function (e) {
      let $this = $(e.currentTarget)
      let $parent = $this.parent()
      let $parentSiblingsUl = $parent.siblings('ul')
      let code = $this.data('code')
      if (!$this.hasClass('select')) {
        $this.parent().find('li').removeClass('select')
        $this.addClass('select')
        $parentSiblingsUl.find('li').removeClass('select')
        $parentSiblingsUl.find('.' + code).addClass('select')
      }
    })
  },
  init: function () {
    var that = this

    $('#analysisText').val(demoTextList[n])
    that.analysis(true)
    that.geetestApi1()
    that.addEvent()
  }
}

$(function () {
  serviceTopbar()
  functionalExperienceModel.init()
})



// WEBPACK FOOTER //
// ./src/js/entry/services/lexicalAnalysis.js